import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Typography, IconButton, CircularProgress } from 'cprime-foundational-components';
import TooltipWrapper from 'components/TooltipWrapper/TooltipWrapper';
import { formatDataValue } from 'utils/formatFns';
import { formatDataTestId, generateTestId } from 'utils/general';

const ProtectedField = ({ field, value, handleClick, enableButton, loading, isPrint = false }) => {
  const getValue = () => {
    if (loading) {
      return <CircularProgress size={16} sx={{ color: 'text.disabled' }} />;
    }
    return value ? formatDataValue({ value }) : 'Protected';
  };

  return (
    <Stack
      data-testid={generateTestId('VehicleRecord', 'ProtectedField', formatDataTestId(field))}
      direction="row"
      alignItems="center"
    >
      <Typography variant="body1" width="4rem">
        {getValue()}
      </Typography>
      {!isPrint && enableButton && (
        <TooltipWrapper
          placement="right"
          tooltipText={
            value
              ? 'Click to protect Key Code.'
              : 'Access to Key Code is recorded. Click here to display Key Code.'
          }
        >
          <IconButton
            disableRipple
            sx={{ '&:hover': { backgroundColor: 'transparent' } }}
            onClick={() => handleClick(field)}
          >
            {value ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
          </IconButton>
        </TooltipWrapper>
      )}
    </Stack>
  );
};

ProtectedField.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  enableButton: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  isPrint: PropTypes.bool,
};

export default ProtectedField;
